export const enum MessageType {
    System = 0,
    Text = 1,
    Image = 2,
    Video = 3,
    Location = 4,
    File = 5,
    ScreenSharing = 6,
    Tech = 7,
    Files = 8,
    SharingStart = 9,
    SharingRequest = 10,
    SharingStop = 11,
    SharingRemoteViewStart = 1003,
    SharingRemoteViewStop = 14,
    Extended = 15,
    Voice = 18,
}
